import { render, staticRenderFns } from "./MallDecorationTab.vue?vue&type=template&id=e926dca0&scoped=true"
import script from "./MallDecorationTab.vue?vue&type=script&lang=js"
export * from "./MallDecorationTab.vue?vue&type=script&lang=js"
import style0 from "./MallDecorationTab.vue?vue&type=style&index=0&id=e926dca0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.0.0_f2752dac7684e9922cbc3a420999c69f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e926dca0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e926dca0')) {
      api.createRecord('e926dca0', component.options)
    } else {
      api.reload('e926dca0', component.options)
    }
    module.hot.accept("./MallDecorationTab.vue?vue&type=template&id=e926dca0&scoped=true", function () {
      api.rerender('e926dca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cardSystem/saleToos/projectDelivery/components/applyForm/MallDecorationTab.vue"
export default component.exports